import React from 'react';

import PropTypes from 'prop-types';

import { FulfillmentPlannerError } from '../../../../../fulfillment-planner/error';
import { RateAndCreateLabel } from '../../../../../fulfillment-planner/rate-and-create-label';
import { RejectedBanner } from '../../../../rejected-banner';
import { RequestedService } from './requested-service';
import { FulfillmentService } from './fulfillment-service';
import { ShipFrom } from './ship-from';
import style from './style.module.less';

export const DrawerExternalConfiguration = ({ fulfillmentPlanId }) => {
  return (
    <div>
      <div className={style['drawer-fulfillment-configuration']}>
        <RejectedBanner className={style['rejected-banner']} fulfillmentPlanId={fulfillmentPlanId} />
        <RequestedService fulfillmentPlanId={fulfillmentPlanId} />
        <ShipFrom fulfillmentPlanId={fulfillmentPlanId} />
        <FulfillmentService />
        <FulfillmentPlannerError className={style['error-container']} />
      </div>
      <RateAndCreateLabel fulfillmentPlanId={fulfillmentPlanId} isQuickshipCompatible />
    </div>
  );
};

DrawerExternalConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
